const getId = (value) =>
  value && typeof value === 'object' ? value._id : value;

const hasSameId = (left, right) => {
  const leftId = getId(left);
  const rightId = getId(right);

  return leftId && rightId && String(leftId) === String(rightId);
};

export const formatGroupLabel = (
  group,
  organizations = [],
  authenticatedOrganization = null
) => {
  const groupOrganization = group.organization || group.event?.organization;
  const populatedOrganization =
    groupOrganization &&
    typeof groupOrganization === 'object' &&
    groupOrganization.name
      ? groupOrganization
      : null;
  const organization =
    populatedOrganization ||
    organizations.find((item) => hasSameId(item, groupOrganization)) ||
    (hasSameId(authenticatedOrganization, groupOrganization)
      ? authenticatedOrganization
      : null);

  return organization?.name
    ? `${group.name} (${organization.name})`
    : group.name;
};
